import { type AppEnvT } from '@ruminati/types_v2/env'

export function getEnvFromUrl(): AppEnvT {
  if (import.meta.env.DEV) return 'local'

  const hostname = window.location.hostname
  if (hostname.indexOf('localhost') > -1) return 'local'
  if (hostname.indexOf('beta-dev') > -1) return 'dev'
  if (hostname.indexOf('app-dev') > -1) return 'dev'
  if (hostname.indexOf('app-staging') > -1) return 'staging'
  if (hostname.indexOf('beta-staging') > -1) return 'staging'
  return 'prod'
}
